import { DATE_LONG_FORMAT, DATE_LONG_FORMAT_WITH_YEAR } from '../../constants/datetime';

export function formatDate(parsedTimestamp, shortFormat = DATE_LONG_FORMAT, longFormat = DATE_LONG_FORMAT_WITH_YEAR) {
    const year = parsedTimestamp.format('YYYY'),
        currentYear = new Date().getFullYear(),
        format = year == currentYear ? shortFormat : longFormat;

    return parsedTimestamp.format(format);
}
